import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white" data-id="element-89" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-90" data-mp="1cf03nb26x4mz">
        <div className="text-center mb-16" data-id="element-91" data-mp="1cgb8le7dgifo">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy uppercase" data-id="element-92" data-mp="2a1ytb1ugtcbd">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-93" data-mp="253x9uft4nazd">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-mist border border-slate-200 rounded-xl overflow-hidden" data-id="element-94" data-mp="202rgcfrn7jos" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ocean" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-95" data-mp="1v7c39q1glrtf">
                <span className="font-bold text-lg text-navy pr-8" data-id="element-96" data-mp="1pm1ptkzvpegy">{faq.q}</span>
                <ChevronDown className={`text-cta transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-97" data-mp="1ap0z9ktfbpk2" />
              </button>
              <AnimatePresence initial={false} data-id="element-98" data-mp="16nyygzjuz5fz">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-99" data-mp="rz2sd81d42i0">
                    <div className="px-6 pb-5 text-slate-700 border-t border-slate-200 pt-4 space-y-2" data-id="element-100" data-mp="mywwffo27tu4">
                      {faq.a.map(paragraph => <p key={paragraph} data-id="element-101" data-mp="2kvx0mmnvvz71">{paragraph}</p>)}
                      {faq.list && <ul className="list-disc pl-5 grid sm:grid-cols-2 gap-x-4 gap-y-1" data-id="element-102" data-mp="2fwalu8seqaw4">
                          {faq.list.map(item => <li key={item} data-id="element-103" data-mp="2azk4li4v9994">{item}</li>)}
                        </ul>}
                      {faq.afterList && <p data-id="element-104" data-mp="33lwm6zkimw5p">{faq.afterList}</p>}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}